<template>
  <div>
    <b-table
      style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: 5px; margin-top: 12px"
      :items="vorgangData"
      :fields="vorgangFields"
      :busy="isVorgangLoading"
      responsive
      hover
      head-variant="light"
      @row-clicked="rowClicked"
    >
      <template #cell(id)="row">
        <div class="d-flex align-items-center" style="gap: 6px">
          <span>{{ row.item.id }}</span>
          <GrWunschIcon :teilnehmers="row.item.teilnehmers ?? []" />
        </div>
      </template>
      <template #cell(statusTickets)="row">
        <div v-html="statusTicketsConverter[row.item.statusTickets] || statusTicketsConverter.Critical"></div>
      </template>
      <template #head(thWertGesamt)>
        <span>TH Gesamt</span>
        <i
          class="fas fa-asterisk text-danger icon-sm"
          title="Zum Zeitpunkt der Buchung"
          v-b-tooltip.hover
          style="align-self: start; position: absolute"
        ></i>
      </template>
      <template #head(thWertInlandsflug)>
        <span>TH Inlandsflug</span>
        <i
          class="fas fa-asterisk text-danger icon-sm"
          title="Zum Zeitpunkt der Buchung"
          v-b-tooltip.hover
          style="align-self: start; position: absolute"
        ></i>
      </template>
      <template #head(thWertMain)>
        <span>TH Langstrecke</span>
        <i
          class="fas fa-asterisk text-danger icon-sm"
          title="Zum Zeitpunkt der Buchung"
          v-b-tooltip.hover
          style="align-self: start; position: absolute"
        ></i>
      </template>

      <template #cell(teilnehmerNames)="row">
        {{ kundenName(row.item) }}
      </template>

      <template #cell(thWertMain)="row">
        <template v-if="!getThwerteAtBuchungsdatumByVorgangIdisLoading(row.item.id)">
          {{ getThwerteAtBuchungsdatumByVorgangId(row.item.id, 'thWertMain') }}
        </template>
        <b-spinner v-else small></b-spinner>
      </template>
      <template #cell(thWertInlandsflug)="row">
        <template v-if="!getThwerteAtBuchungsdatumByVorgangIdisLoading(row.item.id)">
          {{ getThwerteAtBuchungsdatumByVorgangId(row.item.id, 'thWertInlandsflug') }}
        </template>
        <b-spinner v-else small></b-spinner>
      </template>
      <template #cell(thWertGesamt)="row">
        <template v-if="!getThwerteAtBuchungsdatumByVorgangIdisLoading(row.item.id)">
          {{ getThwerteAtBuchungsdatumByVorgangId(row.item.id, 'thWertGesamt') }}
        </template>
        <b-spinner v-else small></b-spinner>
      </template>
      <template #cell(getEarliestTktlFlugbuchung)="row">
        {{ formatTktl(row) }}
      </template>
      <template #cell(aufgaben)="row">
        <b-badge :id="'tooltip-target-vorgang' + row.item.id">
          {{ row.item.aufgaben?.length }}
        </b-badge>
        <b-tooltip
          :target="'tooltip-target-vorgang' + row.item.id"
          triggers="hover"
          custom-class="custom-tooltip"
          v-if="row.item.aufgaben?.length > 1"
        >
          <AufgabenWidget
            :openAufgabenId="openAufgabenId"
            class="mt-3"
            :ansicht="'aufgabe-details'"
            :aufgaben="row.item.aufgaben || []"
          ></AufgabenWidget>
        </b-tooltip>
      </template>
    </b-table>
  </div>
</template>
<script>
import { format, parseISO } from 'date-fns';
import VorgangStateWidget from '@/components/vorgaenge/vorgang-state-widget.vue';
import { GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID } from '@/core/vorgaenge/stores/vorgaenge.module';
import { mapState } from 'vuex';
import AufgabenWidget from '@/components/produkte/reisetermine/aufgaben-widget.vue';
import GrWunschIcon from '@/components/common/gr-wunsch-icon.vue';

export default {
  props: {
    vorgangData: { type: Array, required: true },
    openAufgabenId: { type: Number, default: null },
    aufgabenKategorie: { type: String },
  },
  components: { VorgangStateWidget, AufgabenWidget, GrWunschIcon },
  data() {
    return {
      isVorgangLoading: false,
      statusTicketsConverter: {
        AllGood: '<i class="fas fa-ticket-alt text-success fa-lg"></i>',
        CheckRequired: '<i class="fas fa-ticket-alt text-warning fa-lg"></i>',
        Critical: '<i class="fas fa-ticket-alt text-danger fa-lg"></i>',
      },
      vorgangDataExpanded: [],
      vorgangFields: [
        {
          tdClass: 'align-middle',
          key: 'id',
          label: 'BNR',
        },
        {
          tdClass: 'align-middle',
          key: 'pnr',
          label: 'PNR',
          formatter: value => value.join(', '),
        },
        {
          tdClass: 'align-middle',
          key: 'teilnehmerNames',
          label: 'Teilnehmernamen',
        },
        // aus den BO-Files
        {
          tdClass: 'align-middle',
          key: 'statusTickets',
          label: 'Status Tickets',
        },
        {
          tdClass: 'align-middle',
          key: 'thWertMain',
          label: 'TH Langstrecke',
        },
        {
          tdClass: 'align-middle',
          key: 'thWertInlandsflug',
          label: 'TH Inlandsflug',
        },
        {
          tdClass: 'align-middle',
          key: 'thWertGesamt',
          label: 'TH Gesamt',
        },
        {
          tdClass: 'align-middle',
          key: 'getEarliestTktlFlugbuchung',
          label: 'TKTL',
        },
        { tdClass: 'align-middle', key: 'aufgaben', label: 'Aufgaben' },
      ],
    };
  },
  computed: {
    ...mapState({
      thwerteAtBuchungsdatumByVorgangId: state => state.vorgaenge.thwerteAtBuchungsdatumByVorgangId,
    }),
    jumpIntoVorgangOverview() {
      return (
        this.aufgabenKategorie === 'VorzeitigesTicketing' ||
        this.aufgabenKategorie === 'VorabpruefungTicketBeiGruppe' ||
        this.aufgabenKategorie === 'TicketfreigabeYield' ||
        this.aufgabenKategorie === 'GruppeTicketing' ||
        this.aufgabenKategorie === 'SpecialServices' ||
        this.aufgabenKategorie === 'NegoQuotieren' ||
        this.aufgabenKategorie === 'Individualisierung' ||
        this.aufgabenKategorie === 'Flugbuchung' ||
        this.aufgabenKategorie === 'InlandsflugBuchung' ||
        this.aufgabenKategorie === 'InlandsflugPruefung' ||
        this.aufgabenKategorie === 'InlandsflugAbsprache' ||
        this.aufgabenKategorie === 'Flugpruefung' ||
        this.aufgabenKategorie === 'TicketingAnfrage' ||
        this.aufgabenKategorie === 'FlugplanaenderungAbsprache' ||
        this.aufgabenKategorie === 'SegmenteMismatch'
      );
    },
  },
  watch: {
    vorgangData: {
      handler: function (v) {
        const reiseterminIds = [
          ...new Set(
            this.vorgangData
              .map(vorgang => vorgang.hotelleistungen?.[0]?.reisetermin?.id)
              .filter(id => id != null)
          ),
        ];
        if (reiseterminIds.length === 1) {
          this.$store.dispatch(GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID, {
            reiseterminId: reiseterminIds[0],
            vorgaenge: this.vorgangData,
          });
        }
      },
    },
  },
  mounted() {
    const reiseterminIds = [
      ...new Set(
        this.vorgangData
          .map(vorgang => vorgang.hotelleistungen?.[0]?.reisetermin?.id)
          .filter(id => id != null)
      ),
    ];
    if (reiseterminIds.length === 1) {
      this.$store.dispatch(GET_TH_WERTE_AT_BUCHUNGSDATUM_BY_VORGANG_ID, {
        reiseterminId: reiseterminIds[0],
        vorgaenge: this.vorgangData,
      });
    }
  },
  methods: {
    getThwerteAtBuchungsdatumByVorgangIdisLoading(vorgangId) {
      return this.thwerteAtBuchungsdatumByVorgangId?.[vorgangId]?.isLoading;
    },
    getThwerteAtBuchungsdatumByVorgangId(vorgangId, key) {
      const vorgangData = this.thwerteAtBuchungsdatumByVorgangId?.[vorgangId]?.data;
      if (vorgangData && vorgangData[key]) {
        return this.$options.filters.currency(vorgangData[key]);
      }
      return '-';
    },

    kundenName(item) {
      if (item?.kunde?.master) {
        return item?.kunde?.master.vorname + ' ' + item?.kunde?.master.nachname;
      } else return '';
    },
    formatTktl(row) {
      console.log('row: ', row);
      console.log('row.value: ', row.value);

      if (row.value === null || row.value === '') return '-';
      return format(parseISO(row.value.slice(0, -1)), 'dd.MM.yyyy HH:mm');
    },
    rowClicked(item) {
      if (this.jumpIntoVorgangOverview) {
        window.open('/#/vorgaenge/overview?id=' + item.id, '_blank');
        return;
      }

      const reiseterminId = item.hotelleistungen?.[0]?.reisetermin?.id;
      if (reiseterminId == null) return;
      window.open('/#/reisetermine/' + reiseterminId, '_blank');
    },
  },
};
</script>
<style scoped>
:deep(tbody > tr) {
  cursor: pointer;
}

:deep(.b-table td) {
  vertical-align: middle;
}
</style>
<style>
.custom-tooltip .tooltip-inner {
  max-height: 500px;
  overflow-y: auto;
  text-align: left;
}
</style>
